import { Fragment, FC, useState, useEffect, forwardRef, ReactElement, Ref } from "react";
import {
  Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel,
  Grid, InputAdornment, InputLabel, Select, Slide, Switch, TextField, Typography,
  IconButton,
} from "@mui/material";
import axios, { AxiosInstance } from "axios";
import CheckAttr from "../../../utils/CheckAttr";
import { IAssociationParametrage } from "../../content/parametrage/Operation/Operation";
import { IPays } from "../../content/parametrage/Pays/Pays";
import { urlApi } from "../../content/parametrage/Pays/RowPays";
import { useStyles } from "../styles";
import { LoadingButton } from "@mui/lab";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { AlertType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";

import CheckIcon from "@mui/icons-material/Check";
import { TransitionProps } from "@mui/material/transitions";
import {
  ClientWithChildInterface, DeviseInterface, OperationI, PivOperSocCode
} from "../../content/parametrage/Article/InterfaceArticle";
import Cookies from "universal-cookie";
import { CodeArticleInterface } from "../OperationAjoutForm";
import { DataRef } from "../../../types/DataRef";
import { useSelector } from "react-redux";
import { Reducers } from "../../../redux/reducers";
import ArticleInformation from "../../../types/ArticleInformation";
import { withStyles } from "@material-ui/core";
import { checkViaCodeArticle } from "../../../utils/utils";
import { PORTFOLIO_TYPE, codeArticleNotToDisable, deviseIds_fixed3 } from "../../../constants/Constants";
import { FirstNiveau, IUserRef, SecondNiveau } from "../../content/parametrage/Article/Article";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loggoutUser } from "../../../redux/actions/logginUser";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { frFR } from "@mui/x-date-pickers/locales";
import 'dayjs/locale/fr';

interface IArticleFormsProps {
  // Ref
  dataRefPaysBu: IPays[];
  alltype: DataRef[];
  allActivite: DataRef[];
  allDevise: DeviseInterface[];
  allClientWithChild: ClientWithChildInterface[];
  firstNiveau?: FirstNiveau;
  secondNiveau?: SecondNiveau;
  onClose: () => void;
  reloadList: () => void;
  allUserGRCCommerciaux: IUserRef[];
}

interface InputValidation {
  paysSelected: boolean;
  buSelected: boolean;
  operationSelected: boolean;
  libelle: boolean;
  codeArticleSelected: boolean;
  operationSocieteCodeGescoSelected: boolean;
  deviseSelected: boolean;
  dateDebut: boolean;
  dateFin: boolean;
  firstDateFacturation: boolean;
  TarifHeure: boolean;
  TarifActe: boolean;
  coutA: boolean;
  dateCout: boolean;
  activite: boolean;
}

interface Bus {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}

interface Cout {
  date_debut?: Date;
  coutactivite?: string;
}

export interface ICommissionRow {
  user_id: number | string;
  taux_commission: string;
  nb_mois_commission: string;
}

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const BlackTextTypography = withStyles({})(Typography);

const resetInpuValidation: InputValidation = {
  paysSelected: false,
  buSelected: false,
  operationSelected: false,
  codeArticleSelected: false,
  libelle: false,
  operationSocieteCodeGescoSelected: false,
  firstDateFacturation: false,
  deviseSelected: false,
  dateDebut: false,
  dateFin: false,
  TarifActe: false,
  TarifHeure: false,
  coutA: false,
  dateCout: false,
  activite: false,
};

const ArticleForm: FC<IArticleFormsProps> = ({
  dataRefPaysBu,
  alltype,
  allDevise,
  allActivite,
  allClientWithChild,
  firstNiveau,
  secondNiveau,
  onClose,
  reloadList,
  allUserGRCCommerciaux,
}) => {
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  //Chiffre Apres Virgule
  const chiffreApresVirgule = deviseIds_fixed3.includes(
    secondNiveau?.devise_id as number
  )
    ? 3
    : 2;

  //Redux
  const articleInfo = useSelector<Reducers>(
    (state) => state.articleParm
  ) as ArticleInformation;

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove("jwt", { path: "/" });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const classes = useStyles();

  const [errorInput, setErrorInput] = useState<InputValidation>(resetInpuValidation);

  const [libelleArticle, setLibelleArticle] = useState<string>(
    secondNiveau?.libelle as string
  );

  const [paysSelected, setPaysSelected] = useState<IPays>(
    dataRefPaysBu?.find((x) => x.id === secondNiveau?.pays_id) as IPays
  );

  const [semiAutomatique, setSemiAutomatique] = useState<boolean>(
    secondNiveau?.semi_automatique ?? false
  );

  const [buSelected, setBuSelected] = useState<Bus>(
    dataRefPaysBu
      ?.find((x) => x.id === secondNiveau?.pays_id)
      ?.bus?.find((y) => y.id === secondNiveau?.bu_id) as Bus
  );

  const [clientSelecte, setClientSelected] = useState<ClientWithChildInterface>(
    secondNiveau
      ? (allClientWithChild?.find(
        (cl) => cl.id === secondNiveau?.client_id
      ) as ClientWithChildInterface)
      : (allClientWithChild?.find(
        (cl) => cl.id == articleInfo?.idClient
      ) as ClientWithChildInterface)
  );

  const [associationSelected, setAssociationSelected] =
    useState<IAssociationParametrage>();

  const [loader, setLoader] = useState<boolean>(false);

  //
  const [operationSelected, setOperationSelected] = useState<OperationI>(
    firstNiveau
      ? (allClientWithChild
        ?.find((cl) => cl.id == firstNiveau?.client_id)
        ?.operations.find(
          (op) => op.id == firstNiveau?.operation_id
        ) as OperationI)
      : (allClientWithChild
        ?.find((cl) => cl.id == articleInfo?.idClient)
        ?.operations.find(
          (op) => op.id == articleInfo?.idOPeration
        ) as OperationI)
  );

  const pivotData: PivOperSocCode = {
    id: firstNiveau?.pivot_oper_socifact_id as number,
    operation_id: firstNiveau?.operation_id as number,
    piv_socifact_code_id: firstNiveau?.piv_socifact_code_id as number,
    operation: {
      id: firstNiveau?.operation_id as number,
      libelle: firstNiveau?.operation_libelle as string,
      clients_id: firstNiveau?.client_id as number,
      client: {
        id: firstNiveau?.client_id as number,
        libelle: firstNiveau?.client_libelle as string,
      },
    },
    piv_societe_fact_code: {
      id: firstNiveau?.piv_socifact_code_id as number,
      code_gesco_id: firstNiveau?.code_gesco_id as number,
      societe_facturation_id: firstNiveau?.societe_id as number,
      societe_facturation: {
        id: firstNiveau?.societe_id as number,
        libelle: firstNiveau?.societe_libelle as string,
      },
      code_gesco: {
        id: firstNiveau?.code_gesco_id as number,
        libelle: firstNiveau?.code_gesco_libelle as string,
      },
    },
  };

  const [
    operationSocieteCodeGescoSelected,
    setoperationSocieteCodeGescoSelected,
  ] = useState<PivOperSocCode>(pivotData);

  const codeArticleDatas: CodeArticleInterface = {
    id: secondNiveau?.code_article_id as number,
    libelle: secondNiveau?.code_article_libelle as string,
  };

  const [codeArticleSelected, setCodeArticleSelected] =
    useState<CodeArticleInterface>(codeArticleDatas);

  const [activiteSelected, setAcitviteSelected] = useState<DataRef>(
    allActivite.find((x) => x.id === secondNiveau?.activite_id) as DataRef
  );

  const [typeSelected, setTypeSelected] = useState<DataRef>(
    alltype.find((x) => x.id === secondNiveau?.type_id) as DataRef
  );

  const [deviseSelected, setDeviseSelected] = useState<DeviseInterface>(
    allDevise.find((x) => x.id === secondNiveau?.devise_id) as DeviseInterface
  );

  const [isActive, setIsActive] = useState<boolean>(
    secondNiveau ? secondNiveau?.actif : true
  );

  const [dateDebut, setDateDebut] = useState<Date | null>(
    secondNiveau?.tar_date_debut ?? null
  );

  const [tarifHeure, setTarifHeure] = useState<string>(
    secondNiveau?.tarifheure
      ? parseFloat(secondNiveau?.tarifheure as string).toFixed(
        chiffreApresVirgule
      )
      : ""
  );
  const [tarifActe, setTarifActe] = useState<string>(
    secondNiveau?.tarifacte
      ? parseFloat(secondNiveau?.tarifacte as string).toFixed(
        chiffreApresVirgule
      )
      : ""
  );

  const [articleCout, setArticleCout] = useState<Cout>({
    date_debut: secondNiveau?.couts_date_debut,
    coutactivite: secondNiveau ? secondNiveau?.coutactivite : undefined,
  });

  const [allOperationHasCodeGesco, setAllOperationHasCodeGesco] = useState<
    PivOperSocCode[]
  >([]);

  const [allCodeArticle, setAllCodeArticle] = useState<CodeArticleInterface[]>(
    []
  );

  const [commissions, setCommissions] = useState<ICommissionRow[]>([
    { user_id: "", taux_commission: "", nb_mois_commission: "" }
  ]);

  // Autres
  const [alertType, setAlertType] = useState<AlertType>("success");
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [openModalConfirmation, setOpenModalConfirmation] =
    useState<boolean>(false);
  const [loaderButton, setLoaderButton] = useState<boolean>(false);
  const [dateDebutParent, setDateDebutParent] = useState<string>();

  const [firstDateFacturation, setFirstDateFacturation] = useState<Dayjs | null>(null);
  const [typeIsDisable, setTypeIsDisable] = useState<boolean>();

  useEffect(() => {
    if (secondNiveau && secondNiveau?.date_first_facturation) {
      setFirstDateFacturation(dayjs(secondNiveau?.date_first_facturation));
    }
  }, []);


  const handleAddCommission = () => {
    setCommissions([...commissions, { user_id: "", taux_commission: "", nb_mois_commission: "" }]);
  };

  const handleRemoveCommission = (index: number) => {
    const list = [...commissions];
    list.splice(index, 1);
    setCommissions(list);
  };

  const handleCommissionChange = (index: number, field: keyof ICommissionRow, value: string | number) => {
    const list = [...commissions];
    list[index] = { ...list[index], [field]: value };
    setCommissions(list);
  };

  const getOperationHasCodeGesco = (idOperation: any) => {
    idOperation !== undefined && setLoader(true);
    idOperation !== undefined &&
      http
        .get(`operationhascode/findby/operation/${idOperation}`)
        .then((res) => {
          Array.isArray(res.data) &&
            setAllOperationHasCodeGesco(res.data as PivOperSocCode[]);

          if (
            secondNiveau?.id === undefined &&
            articleInfo?.idClient !== undefined
          ) {
            const allTempPivotOperSOcCode = res.data;
            setoperationSocieteCodeGescoSelected(
              allTempPivotOperSOcCode?.find(
                (piv: PivOperSocCode) => piv.id == articleInfo?.idPivot
              )
            );
          }
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        });
  };

  const getCodeArticleBySocieteId = (idSociete: any) => {
    setLoaderButton(true);
    http
      .get(`article/findby/societe/${idSociete}`)
      .then((res) => {
        Array.isArray(res.data) &&
          setAllCodeArticle(res.data as CodeArticleInterface[]);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoaderButton(false);
      });
  };

  const getCommissionByArticle = (idArticle: any) => {
    setLoader(true);
    http
      .get(`article/commission/by/article/${idArticle}`)
      .then((res) => {
        const tmpCommissions: ICommissionRow[] = res.data.map((c: any) => ({
          user_id: c?.user_id,
          taux_commission: c?.taux_commission,
          nb_mois_commission: c?.nb_mois_commission
        }));

        setCommissions(tmpCommissions);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoaderButton(false);
      });
  };

  const isValidate = (): boolean => {
    if (
      !CheckAttr(paysSelected?.id) ||
      !CheckAttr(buSelected?.id) ||
      !CheckAttr(operationSelected?.id) ||
      !CheckAttr(operationSocieteCodeGescoSelected?.id) ||
      !CheckAttr(codeArticleSelected?.id) ||
      !CheckAttr(libelleArticle) ||
      !CheckAttr(deviseSelected?.id) ||
      (!CheckAttr(tarifHeure) && !CheckAttr(tarifActe)) ||
      !CheckAttr(dateDebut) ||
      !CheckAttr(articleCout?.coutactivite) ||
      !CheckAttr(articleCout?.date_debut) ||
      !CheckAttr(activiteSelected?.id) ||
      // Si il n'y a pas firstDateFacturation et pas Modifier et pas Portfolio  
      (!firstDateFacturation?.isValid() && !CheckAttr(secondNiveau) && typeSelected?.id !== PORTFOLIO_TYPE)
    ) {
      if (!CheckAttr(paysSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          paysSelected: true,
        }));
      }

      if (!CheckAttr(buSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          buSelected: true,
        }));
      }
      if (!CheckAttr(operationSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          operationSelected: true,
        }));
      }
      if (!CheckAttr(operationSocieteCodeGescoSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          operationSocieteCodeGescoSelected: true,
        }));
      }
      if (!CheckAttr(codeArticleSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          codeArticleSelected: true,
        }));
      }
      if (!CheckAttr(libelleArticle)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          libelle: true,
        }));
      }
      if (!CheckAttr(deviseSelected)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          deviseSelected: true,
        }));
      }
      if (!CheckAttr(activiteSelected)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          activite: true,
        }));
      }
      if (!CheckAttr(tarifHeure) && !CheckAttr(tarifActe)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          TarifActe: true,
          TarifHeure: true,
        }));
      }

      if (!CheckAttr(dateDebut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateDebut: true,
        }));
      }

      if (!CheckAttr(firstDateFacturation) && !CheckAttr(secondNiveau)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          firstDateFacturation: true,
        }));
      }

      if (!CheckAttr(articleCout?.coutactivite)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          coutA: true,
        }));
      }

      if (!CheckAttr(articleCout?.date_debut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateCout: true,
        }));
      }
      return false;
    }
    return true;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "pays") {
      setPaysSelected(dataRefPaysBu.find((x) => x.id == value) as IPays);

      setBuSelected(paysSelected?.bus.find((x) => x.id == 0) as Bus);

      /*setCodeArticleSelected(
        allCodeArticle?.find((x) => x.id == 0) as CodeArticleInterface
      );*/
    }

    if (name === "bu") {
      setBuSelected(paysSelected?.bus.find((x) => x.id == value) as Bus);

      /*setCodeArticleSelected(
        allCodeArticle?.find((x) => x.id == 0) as CodeArticleInterface
      );*/
    }

    if (name === "client") {
      setClientSelected(
        allClientWithChild?.find(
          (x) => x.id == value
        ) as ClientWithChildInterface
      );

      setCodeArticleSelected(
        allCodeArticle?.find((x) => x.id == 0) as CodeArticleInterface
      );
    }

    if (name === "operation") {
      setOperationSelected(
        clientSelecte?.operations?.find((x) => x.id == value) as OperationI
      );

      /*setCodeArticleSelected(
        allCodeArticle?.find((x) => x.id == 0) as CodeArticleInterface
      );*/
    }

    if (name === "sociteCode") {
      const OperationHasCodeSocieteTemp: PivOperSocCode =
        allOperationHasCodeGesco?.find((x) => x.id == value) as PivOperSocCode;
      setoperationSocieteCodeGescoSelected(OperationHasCodeSocieteTemp);
    }

    if (name === "codeArticle") {
      const articleTemp: CodeArticleInterface = allCodeArticle?.find(
        (x) => x.id == value
      ) as CodeArticleInterface;
      setCodeArticleSelected(articleTemp);
      // Test Si on Supprime La Valeur De la Tarif
      if (
        checkViaCodeArticle(
          codeArticleNotToDisable,
          ["A", "a"],
          articleTemp?.libelle
        )
      ) {
        setTarifHeure("");
      } else if (
        checkViaCodeArticle(
          codeArticleNotToDisable,
          ["H", "h"],
          articleTemp?.libelle
        )
      ) {
        setTarifActe("");
      }
    }

    if (name === "date_debut") {
      setDateDebut(value);
    }
  };

  const handleSave = () => {
    if (isValidate()) {
      if (firstDateFacturation) {
        const t = firstDateFacturation
      }
      const data = {
        assoId: associationSelected?.id,
        paysId: paysSelected?.id,
        buId: buSelected?.id,
        OSCG: operationSocieteCodeGescoSelected?.id,
        codeArticleId: codeArticleSelected?.id,
        libelle: libelleArticle,
        activiteId: activiteSelected?.id,
        typeId: typeSelected?.id,
        deviseId: deviseSelected?.id,
        actif: isActive,
        id: secondNiveau?.id,
        dateDebu: dateDebut,
        tarifActe: tarifActe,
        tarifHeure: tarifHeure,
        cout: articleCout,
        semiAutomatique,
        tarif_id: secondNiveau?.tarif_id,
        couts_id: secondNiveau?.couts_id,
        commissions: commissions.filter(c => c.user_id !== ""),
        firstDateFacturation: firstDateFacturation ? firstDateFacturation?.format('YYYY-MM-DD') : undefined
      };

      setLoaderButton(true);

      http.post(`create/article`, data)
        .then((res) => {
          if (typeof res.data == "string") {
            // Redodance
            setAlertType("warning");
            setAlerteMessage(res.data);
            setOpenSnack(true);
          } else {
            onClose();
            reloadList();
          }
        }).catch((error) => {
          console.log(error);
        }).finally(() => {
          setLoaderButton(false);
        });
    } else {
      setAlertType("warning");
      setAlerteMessage("vous devez remplir les champs obligatoires");
      setOpenSnack(true);
    }
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  useEffect(() => {
    // Get All CodeGesco By Operation Par Operation Redux  Ou Operation Selected
    operationSelected?.id !== undefined
      ? getOperationHasCodeGesco(operationSelected?.id)
      : getOperationHasCodeGesco(articleInfo?.idOPeration);
  }, [operationSelected?.id]);

  useEffect(() => {
    // Get Code Article By Societe
    operationSocieteCodeGescoSelected?.id &&
      getCodeArticleBySocieteId(
        operationSocieteCodeGescoSelected?.piv_societe_fact_code
          ?.societe_facturation?.id
      );
  }, [operationSocieteCodeGescoSelected?.id]);

  useEffect(() => {
    // get DateFin
    http
      .get(
        `article/get-date-debut-parent-for/Tarification/${secondNiveau?.tarif_id}`
      )
      .then((res) => {
        setDateDebutParent(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Get Commission by Article
    secondNiveau?.id && getCommissionByArticle(secondNiveau?.id);
  }, []);

  /*useEffect(() => {
    // typeSelected?.id === 2 && setTauxCommission("0");
    setTypeIsDisable(typeSelected?.id === PORTFOLIO_TYPE || !CheckAttr(idCommercialDRC));
  }, [typeSelected, idCommercialDRC]);*/

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  const handleChangeCout = (e: any): void => {
    const { name, value } = e.target;

    setArticleCout({
      ...articleCout,
      [name]: value,
    });
  };

  const disableHeureInput = (): boolean => {
    if (
      CheckAttr(tarifActe) ||
      checkViaCodeArticle(
        codeArticleNotToDisable,
        ["A", "a"],
        codeArticleSelected?.libelle
      )
    ) {
      return true;
    }

    return false;
  };

  const disableActeInput = (): boolean => {
    if (
      CheckAttr(tarifHeure) ||
      checkViaCodeArticle(
        codeArticleNotToDisable,
        ["H", "h"],
        codeArticleSelected?.libelle
      )
    ) {
      return true;
    }

    return false;
  };

  return (
    <Fragment>
      {stackAlert}
      <Box>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel htmlFor="pays" color="warning" shrink={CheckAttr(paysSelected?.id)}>
                Pays
              </InputLabel>
              <Select
                id="pays"
                native
                color="warning"
                error={errorInput.paysSelected}
                value={paysSelected?.id}
                onChange={handleChange}
                label="Pays"
                inputProps={{
                  name: "pays",
                }}
              >
                <option value=""></option>
                {dataRefPaysBu.map((pays) => (
                  <option key={pays?.id} value={pays?.id}>
                    {pays?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel htmlFor="bu" color="warning" shrink={CheckAttr(buSelected?.id)}>
                Business Unit
              </InputLabel>
              <Select
                id="bu"
                native
                color="warning"
                error={errorInput.buSelected}
                value={buSelected?.id}
                onChange={handleChange}
                label="Business Unit"
                inputProps={{
                  name: "bu",
                }}
              >
                <option value=""></option>
                {paysSelected?.bus.map((bu) => (
                  <option key={bu?.id} value={bu?.id}>
                    {bu?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="client"
                color="warning"
                shrink={CheckAttr(clientSelecte?.id)}
              >
                Client
              </InputLabel>
              <Select
                disabled={secondNiveau?.has_saisie}
                id="client"
                native
                color="warning"
                value={clientSelecte?.id}
                onChange={handleChange}
                label="Client"
                inputProps={{
                  name: "client",
                }}
              >
                <option value=""></option>
                {allClientWithChild.map((cl) => (
                  <option key={cl?.id} value={cl?.id}>
                    {cl?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={CheckAttr(operationSelected?.id)}
              >
                Opérations
              </InputLabel>
              <Select
                id="operation"
                native
                color="warning"
                error={errorInput.operationSelected}
                value={operationSelected?.id}
                onChange={handleChange}
                label="Opérations"
                inputProps={{
                  name: "operation",
                }}
              >
                <option value=""></option>
                {clientSelecte?.operations?.map((operation) => (
                  <option key={operation?.id} value={operation?.id}>
                    {operation?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="societeCode"
                color="warning"
                shrink={CheckAttr(operationSocieteCodeGescoSelected?.id)}
              >
                Societe Facturation - code Gesco
              </InputLabel>
              <Select
                id="societeCode"
                native
                color="warning"
                error={errorInput.operationSocieteCodeGescoSelected}
                value={operationSocieteCodeGescoSelected?.id}
                onChange={handleChange}
                label="Societe Facturation - code Gesco"
                inputProps={{
                  name: "sociteCode",
                }}
              >
                <option value=""></option>
                {allOperationHasCodeGesco?.map((opSocCG) => (
                  <option key={opSocCG?.id} value={opSocCG?.id}>
                    {
                      opSocCG?.piv_societe_fact_code?.societe_facturation
                        ?.libelle
                    }{" "}
                    - {opSocCG?.piv_societe_fact_code?.code_gesco?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="codeArticle"
                color="warning"
                shrink={CheckAttr(codeArticleSelected?.id)}
              >
                Code Article
              </InputLabel>
              <Select
                id="codeArticle"
                native
                color="warning"
                error={errorInput.codeArticleSelected}
                value={codeArticleSelected?.id}
                onChange={handleChange}
                label="Code Article"
                inputProps={{
                  name: "codeArticle",
                }}
              >
                <option value=""></option>
                {allCodeArticle?.map((codeArticle) => (
                  <option key={codeArticle?.id} value={codeArticle?.id}>
                    {codeArticle?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <TextField
                name="libelleClient"
                label="Libelle"
                color="warning"
                fullWidth
                error={errorInput.libelle}
                autoComplete="off"
                value={libelleArticle}
                onChange={(e) => setLibelleArticle(e.target.value)}
                InputLabelProps={{
                  shrink: CheckAttr(libelleArticle),
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={CheckAttr(activiteSelected?.id)}
              >
                Activité
              </InputLabel>
              <Select
                id="activite"
                native
                color="warning"
                error={errorInput.activite}
                value={activiteSelected?.id}
                onChange={(e) =>
                  setAcitviteSelected(
                    allActivite.find((x) => x.id == e.target.value) as DataRef
                  )
                }
                label="Activité"
                inputProps={{
                  name: "activite",
                }}
              >
                <option value=""></option>
                {allActivite?.map((activite) => (
                  <option key={activite?.id} value={activite?.id}>
                    {activite?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={CheckAttr(typeSelected?.id)}
              >
                Type
              </InputLabel>
              <Select
                id="activite"
                native
                color="warning"
                value={typeSelected?.id}
                onChange={(e) => {
                  const typeTest: DataRef = alltype.find(
                    (x) => x.id == e.target.value
                  ) as DataRef;
                  setTypeSelected(typeTest);
                }}
                label="Activité"
                inputProps={{
                  name: "activite",
                }}
              >
                <option value=""></option>
                {alltype?.map((type) => (
                  <option key={type?.id} value={type?.id}>
                    {type?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={CheckAttr(deviseSelected?.id)}
              >
                Devise De Facturation
              </InputLabel>
              <Select
                disabled={secondNiveau?.has_saisie}
                id="activite"
                native
                color="warning"
                error={errorInput.deviseSelected}
                value={deviseSelected?.id}
                onChange={(e) =>
                  setDeviseSelected(
                    allDevise.find(
                      (x) => x.id == e.target.value
                    ) as DeviseInterface
                  )
                }
                label="Activité"
                inputProps={{
                  name: "activite",
                }}
              >
                <option value=""></option>
                {allDevise?.map((devise) => (
                  <option key={devise?.id} value={devise?.id}>
                    {devise?.code_iso}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
              <DatePicker
                label="Date de la première facture"
                views={["month", "year"]}
                localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
                value={firstDateFacturation}
                onChange={(e) => setFirstDateFacturation(e)}
                readOnly={typeSelected?.id === PORTFOLIO_TYPE}
                slotProps={{
                  textField: {
                    color: "warning",
                    fullWidth: true,
                    error: errorInput?.firstDateFacturation,
                    InputLabelProps: {
                      shrink: true,
                    },
                    sx: { mt: 1, ml: 1 },
                  },
                  desktopPaper: {
                    sx: {
                      '.MuiPickersMonth-monthButton.Mui-selected': {
                        backgroundColor: '#f57c00',
                      },
                      '.MuiPickersYear-yearButton.Mui-selected': {
                        backgroundColor: '#f57c00',
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          {/** Modifier 04-02-2026 */}
          {/* Section Commissions Dynamiques */}
          <Grid item xs={12}>
            <Divider
              textAlign="center"
              sx={{
                my: 2,
                color: "warning.main",
                "&::before, &::after": {
                  borderColor: "warning.main",
                }
              }}
            >
              Commissions Commerciales
            </Divider>
          </Grid>

          {commissions.map((item, index) => (
            <Grid
              container
              spacing={2}
              alignItems="center"
              key={index}
            >
              {/* Commercial */}
              <Grid item xs={12} md={3.7}>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  fullWidth
                >
                  <InputLabel
                    color="warning"
                    htmlFor={`user_id_${index}`}
                    shrink
                  >
                    Commercial / DRC
                  </InputLabel>
                  <Select
                    native
                    id={`user_id_${index}`}
                    label="Commercial / DRC"
                    color="warning"
                    value={item?.user_id}
                    onChange={(e) =>
                      handleCommissionChange(index, "user_id", e.target.value)
                    }
                  >
                    <option value="" />
                    {allUserGRCCommerciaux?.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.prenom} {user.name.toUpperCase()}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Taux */}
              <Grid item xs={12} md={3.7}>
                <TextField
                  label="Taux (%)"
                  color="warning"
                  size="small"
                  fullWidth
                  value={item.taux_commission}
                  onChange={(e) =>
                    handleCommissionChange(index, "taux_commission", e.target.value)
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Nb mois */}
              <Grid item xs={12} md={3.7}>
                <TextField
                  label="Nb Mois"
                  type="number"
                  color="warning"
                  size="small"
                  fullWidth
                  value={item?.nb_mois_commission}
                  onChange={(e) =>
                    handleCommissionChange(index, "nb_mois_commission", e.target.value)
                  }
                  placeholder="Ex: 12"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Delete */}
              <Grid
                item
                xs={12}
                md
                display="flex"
                justifyContent={{ xs: "flex-end", md: "flex-end" }}
                alignItems="center"
              >
                {commissions.length > 1 && (
                  <IconButton
                    color="error"
                    onClick={() => handleRemoveCommission(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          ))}

          <Grid container sx={{ ml: 1, mt: 0.5 }}>
            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="flex-start"
            >
              <Button
                variant="outlined"
                color="warning"
                sx={{ textTransform: 'none' }}
                startIcon={<AddCircleIcon />}
                onClick={handleAddCommission}
              >
                Ajouter un commercial
              </Button>
            </Grid>
          </Grid>

          {secondNiveau?.id && (
            <Grid item xs={6} sm={6} md={2} sx={{ mt: 3 }}>
              <FormControl component="fieldset" variant="standard">
                <FormLabel component="legend" color="warning">
                  Statut de l'article:
                </FormLabel>
                <FormControlLabel
                  control={
                    <Switch
                      defaultChecked
                      value={isActive}
                      checked={isActive}
                      onChange={() => setIsActive(!isActive)}
                      color="warning"
                    />
                  }
                  label={
                    <Typography color="black">
                      {isActive ? "Activer" : "Désactiver"}
                    </Typography>
                  }
                />
              </FormControl>
            </Grid>
          )}

          <Grid item xs={6} sm={6} md={2} sx={{ mt: 3 }}>
            <FormControl component="fieldset" variant="standard">
              <FormLabel component="legend" color="warning">
                Semi-automatique :
              </FormLabel>
              <FormControlLabel
                control={
                  <Switch
                    defaultChecked
                    value={semiAutomatique}
                    checked={semiAutomatique}
                    onChange={() => setSemiAutomatique(!semiAutomatique)}
                    color="warning"
                  />
                }
                label={
                  <Typography color="black">
                    {semiAutomatique ? "Oui" : "Non"}
                  </Typography>
                }
              />
            </FormControl>
          </Grid>

          <Fragment>
            <Divider sx={{ my: 2 }} />
            <Grid item xs={12} mt={2}>
              <Box position="static" className={classes.titleContainer}>
                <BlackTextTypography variant="h6">Tarif</BlackTextTypography>
                <Divider />
              </Box>
            </Grid>

            <Grid item xs={6} sm={4} md={1.4}>
              <TextField
                name="date_debut"
                label="Date debut"
                type="date"
                color="warning"
                fullWidth
                value={dateDebut}
                error={errorInput.dateDebut}
                inputProps={{
                  min: dateDebutParent,
                }}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={
                  (secondNiveau?.tar_date_fin !== null ||
                    (secondNiveau?.id !== null &&
                      secondNiveau?.tar_parent_id === null)) &&
                  CheckAttr(secondNiveau)
                }
              />
            </Grid>
            <Grid item xs={6} sm={4} md={1.3}>
              <TextField
                type="number"
                name="tarif_heure"
                label="Tarif Heure"
                color="warning"
                fullWidth
                autoComplete="off"
                value={tarifHeure}
                error={errorInput.TarifHeure}
                onChange={(e) => setTarifHeure(e.target.value)}
                disabled={
                  disableHeureInput() ||
                  (secondNiveau?.tar_date_fin !== null &&
                    CheckAttr(secondNiveau))
                }
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder="Ex: 1.86"
              />
            </Grid>
            <Grid item xs={6} sm={4} md={1.3}>
              <TextField
                type="number"
                name="tarif_acte"
                label="Tarif Acte"
                color="warning"
                error={errorInput.TarifActe}
                fullWidth
                autoComplete="off"
                disabled={
                  disableActeInput() ||
                  (secondNiveau?.tar_date_fin !== null &&
                    CheckAttr(secondNiveau))
                }
                value={tarifActe}
                onChange={(e) => setTarifActe(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 0.01,
                  lang: "en-US",
                }}
                placeholder="Ex: 1.86"
              />
            </Grid>
          </Fragment>

          <Fragment>
            <Grid item xs={12}>
              <Box position="static" className={classes.titleContainer}>
                <BlackTextTypography variant="h6">Coût</BlackTextTypography>
                <Divider />
              </Box>
            </Grid>

            <Grid item xs={6} sm={6} md={2}>
              <TextField
                name="date_debut"
                label="Date debut"
                type="date"
                color="warning"
                fullWidth
                value={articleCout?.date_debut}
                onChange={handleChangeCout}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errorInput.dateCout}
                disabled={
                  (secondNiveau?.couts_date_fin !== null ||
                    secondNiveau?.couts_parent_id === null) &&
                  CheckAttr(secondNiveau)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <TextField
                name="coutactivite"
                color="warning"
                type="number"
                fullWidth
                autoComplete="off"
                label="Coût activité"
                placeholder="Ex: 2.02"
                error={errorInput.coutA}
                inputProps={{
                  step: 0.01,
                  lang: "en-US",
                }}
                value={articleCout?.coutactivite}
                onChange={handleChangeCout}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={
                  secondNiveau?.couts_date_fin !== null &&
                  CheckAttr(secondNiveau)
                }
              />
            </Grid>
          </Fragment>
        </Grid>
        <Box display="flex" justifyContent="center" mt={5}>
          <LoadingButton
            onClick={() => handleSave()}
            endIcon={<BorderColorIcon />}
            loading={loaderButton}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Enregistrer
          </LoadingButton>
        </Box>
      </Box>
      <Dialog
        open={openModalConfirmation}
        TransitionComponent={Transition}
        keepMounted
        onClose={(e) => setOpenModalConfirmation(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="xs"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {alertMessage}
            <br />
            <br />
            Voulez-vous continuer ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            endIcon={<CheckIcon />}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
            loading={loaderButton}
            size="small"
          >
            Oui
          </LoadingButton>
          <Button
            onClick={(e) => setOpenModalConfirmation(false)}
            variant="contained"
            color="inherit"
            sx={{ textTransform: "none" }}
            startIcon={<ExitToAppIcon />}
            size="small"
          >
            Non
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </Fragment>
  );
};

export default ArticleForm;
